/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesPaymentType } from './WebApiModelsEnumerationTypesPaymentType';
import {
    WebApiModelsEnumerationTypesPaymentTypeFromJSON,
    WebApiModelsEnumerationTypesPaymentTypeFromJSONTyped,
    WebApiModelsEnumerationTypesPaymentTypeToJSON,
} from './WebApiModelsEnumerationTypesPaymentType';

/**
 * 
 * @export
 * @interface WebApiIntegrationsDtoCreateMultiplePaymentLinkDto
 */
export interface WebApiIntegrationsDtoCreateMultiplePaymentLinkDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateMultiplePaymentLinkDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoCreateMultiplePaymentLinkDto
     */
    amount?: number;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesPaymentType}
     * @memberof WebApiIntegrationsDtoCreateMultiplePaymentLinkDto
     */
    paymentType?: WebApiModelsEnumerationTypesPaymentType;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateMultiplePaymentLinkDto
     */
    paymentTypeEntity?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof WebApiIntegrationsDtoCreateMultiplePaymentLinkDto
     */
    memberIds?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoCreateMultiplePaymentLinkDto
     */
    connectedYear?: string | null;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoCreateMultiplePaymentLinkDto interface.
 */
export function instanceOfWebApiIntegrationsDtoCreateMultiplePaymentLinkDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoCreateMultiplePaymentLinkDtoFromJSON(json: any): WebApiIntegrationsDtoCreateMultiplePaymentLinkDto {
    return WebApiIntegrationsDtoCreateMultiplePaymentLinkDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoCreateMultiplePaymentLinkDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoCreateMultiplePaymentLinkDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'paymentType': !exists(json, 'paymentType') ? undefined : WebApiModelsEnumerationTypesPaymentTypeFromJSON(json['paymentType']),
        'paymentTypeEntity': !exists(json, 'paymentTypeEntity') ? undefined : json['paymentTypeEntity'],
        'memberIds': !exists(json, 'memberIds') ? undefined : json['memberIds'],
        'connectedYear': !exists(json, 'connectedYear') ? undefined : json['connectedYear'],
    };
}

export function WebApiIntegrationsDtoCreateMultiplePaymentLinkDtoToJSON(value?: WebApiIntegrationsDtoCreateMultiplePaymentLinkDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'amount': value.amount,
        'paymentType': WebApiModelsEnumerationTypesPaymentTypeToJSON(value.paymentType),
        'paymentTypeEntity': value.paymentTypeEntity,
        'memberIds': value.memberIds,
        'connectedYear': value.connectedYear,
    };
}

